export default __webpack_public_path__ + "static/media/Vehicle.dadc1d67.svg";